import {Spin} from 'antd';
import React, {lazy, Suspense} from 'react';

const SignUpTermsFullContent = lazy(async () => {
  return await import('./SignUpTermsFullContent');
});

export interface SignUpTermsPlaceholderContentProps {
  /** Called after lazy terms chunk mounts so the parent can re-measure scroll height. */
  onContentReady?: () => void;
}

/**
 * Lazy-loads full General Terms and Conditions from `SignUpTermsFullContent.tsx`.
 */
export const SignUpTermsPlaceholderContent: React.FC<
  SignUpTermsPlaceholderContentProps
> = ({onContentReady}) => (
  <div className="signup-terms-doc">
    <Suspense
      fallback={
        <div className="signup-terms-doc--bare">
          <div className="signup-terms-loading">
            <Spin tip="Loading terms…" />
          </div>
        </div>
      }
    >
      <SignUpTermsFullContent onContentReady={onContentReady} />
    </Suspense>
  </div>
);
